import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout title="TERMS & CONDITIONS">
      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">TERMS OF USE</h2>
        <p className="mt-3">These Terms and Conditions, together with the documents referred to herein (“Terms”), constitute a legally binding agreement between you and Hola World Private Limited, hereinafter referred to as “Hola World”, governing your access to and use of services provided through our Australian website holaworld.com.au (“Website”).</p>
        <p className="mt-3">This electronic record is generated in accordance with applicable electronic transaction laws and does not require physical or digital signatures.</p>
        <p className="mt-3">The Website is owned and operated by Hola World Private Limited, operating under the brand name Hola World, providing migration guidance, international education consultancy, and related support services for individuals seeking opportunities in Australia.</p>
        <p className="mt-3">By accessing or using this Website, you agree to comply with and be bound by these Terms and our Privacy Policy.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">GENERAL TERMS</h2>
        <p className="mt-3">The section headings in these Terms are for organizational purposes only and do not affect interpretation.</p>
        <p className="mt-3">Your use of the Website is governed by these Terms and the Privacy Policy published on the Website. Hola World may update these Terms at any time without prior notice.</p>
        <p className="mt-3">By continuing to use the Website, you confirm that:</p>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>you have read and understood these Terms;</li>
          <li>you agree to be legally bound by them;</li>
          <li>you accept any future modifications.</li>
        </ul>
        <p className="mt-3">If you do not agree with any part of these Terms, you must discontinue use of the Website immediately.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">ELIGIBILITY</h2>
        <p className="mt-3">By using this Website, you represent that:</p>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>you are legally capable of entering a binding agreement;</li>
          <li>you are at least 18 years of age or using the Website under supervision of a parent or legal guardian;</li>
          <li>you will comply with all applicable laws and regulations.</li>
        </ul>
        <p className="mt-3">Parents or guardians accept responsibility for minors using the Website.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">NATURE OF SERVICES</h2>
        <p className="mt-3">Hola World provides Australian migration guidance and process support, international education consultation, student visa documentation guidance, application preparation assistance, and settlement and advisory support.</p>
        <p className="mt-3">Hola World does not guarantee visa approval, migration outcomes, or processing timelines.</p>
        <p className="mt-3">All decisions regarding visas and immigration matters are made solely by the Department of Home Affairs or other relevant authorities.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">MIGRATION & PROFESSIONAL ADVICE DISCLAIMER</h2>
        <p className="mt-3">Hola World provides guidance based on publicly available immigration policies and professional experience.</p>
        <p className="mt-3">Information provided on this Website does not constitute legal advice.</p>
        <p className="mt-3">Migration laws and policies may change without notice.</p>
        <p className="mt-3">Where required by law, users may be referred to appropriately registered migration professionals.</p>
        <p className="mt-3">Users are encouraged to seek independent professional advice before making migration decisions.</p>
        <p className="mt-3">Applicants remain responsible for meeting eligibility criteria and complying with requirements set by the Department of Home Affairs.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">CONTENT & INTELLECTUAL PROPERTY</h2>
        <p className="mt-3">All graphics, text, logos, images, design elements, and materials on this Website are protected by intellectual property laws.</p>
        <p className="mt-3">Content may include information submitted by users or third parties. Hola World does not guarantee accuracy or authenticity of such content.</p>
        <p className="mt-3">You agree:</p>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>not to copy, reproduce, distribute, or exploit Website content without written permission;</li>
          <li>not to use content for unlawful or misleading purposes;</li>
          <li>to ensure all submitted information is lawful and accurate.</li>
        </ul>
        <p className="mt-3">Hola World reserves the right to remove content and suspend accounts for misuse.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">USER RESPONSIBILITIES</h2>
        <p className="mt-3">By using this Website, you agree to:</p>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>provide accurate and current information;</li>
          <li>maintain confidentiality of personal information;</li>
          <li>use the Website only for lawful purposes;</li>
          <li>avoid impersonation or fraudulent representation;</li>
          <li>not attempt unauthorized system access;</li>
          <li>not use bots, scraping tools, or automated systems.</li>
        </ul>
        <p className="mt-3">You must not upload or share content that infringes intellectual property rights, is abusive, defamatory, obscene, or unlawful, threatens public order or security, misleads recipients, or violates applicable laws.</p>
        <p className="mt-3">Hola World may suspend or terminate access for violations.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">PRIVACY & DATA HANDLING</h2>
        <p className="mt-3">By submitting personal information and documents, you consent to their use for application and documentation support, communication and service delivery, submission to institutions, partners, or authorities where required, and legal/compliance obligations.</p>
        <p className="mt-3">Hola World implements reasonable security measures to protect personal data. However, transmission over the internet carries inherent risks.</p>
        <p className="mt-3">Personal information may be disclosed where required by law or governmental authorities.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">LIMITATION OF LIABILITY</h2>
        <p className="mt-3">To the fullest extent permitted by law, Hola World shall not be liable for any loss or damages arising from visa refusals, delays, policy changes, decisions made by immigration authorities, inaccurate information provided by users, technical failures, third-party actions, delays in communication, or reliance on Website information.</p>
        <p className="mt-3">Hola World shall not be liable for indirect, incidental, consequential, or special damages.</p>
        <p className="mt-3">Your sole remedy for dissatisfaction is to discontinue use of the Website.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">PAYMENT, FEES & REFUNDS</h2>
        <p className="mt-3">Where services are provided for a fee, service fees may apply and may be non-refundable once work has commenced. Refunds, if applicable, are assessed according to the service agreement provided at enrolment.</p>
        <p className="mt-3">Government fees, institutional charges, and third-party payments are non-refundable unless specified by the issuing authority.</p>
        <p className="mt-3">Detailed service agreements may be provided separately.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">COMMUNICATION CONSENT</h2>
        <p className="mt-3">By providing contact details, you consent to receiving communications via phone calls, email, and messaging services regarding enquiries, services, application updates, and important notifications.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">TERMINATION</h2>
        <p className="mt-3">Hola World reserves the right to suspend or terminate user access at any time, restrict services without prior notice, and discontinue Website operations.</p>
        <p className="mt-3">Termination does not limit legal remedies available to Hola World.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">AUSTRALIAN CONSUMER LAW</h2>
        <p className="mt-3">Nothing in these Terms excludes, restricts, or modifies rights available under the Australian Consumer Law or other applicable consumer protection laws.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">GOVERNING LAW & JURISDICTION</h2>
        <p className="mt-3">These Terms shall be governed by applicable laws and regulations governing international service delivery. Where services relate to Australian migration or education processes, relevant Australian laws and regulatory requirements shall apply.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">SEVERABILITY</h2>
        <p className="mt-3">If any provision of these Terms is held invalid or unenforceable, the remaining provisions remain in full force.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">ENTIRE AGREEMENT</h2>
        <p className="mt-3">These Terms, together with the Privacy Policy and any service agreements, constitute the entire agreement governing Website use.</p>
      </section>

      <section>
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900">CONTACT</h2>
        <p className="mt-3">If you have questions regarding these Terms or Website usage, contact:</p>
        <p className="mt-3">Hola World Private Limited<br />Email: info@holaworld.com.au<br />Website: holaworld.com.au</p>
      </section>
    </LegalPageLayout>
  );
}
